import {QueryClient, QueryClientProvider, QueryCache} from "react-query";
import useFeedback from "./components/feedback/useFeedback";
import {useEffect, useState} from "react";
import {getSessionStatus, subscribeSession} from "./shared/keycloak";

export const retryQuery = (count, error) =>
    ![400, 401, 403, 404].includes(error?.status) &&
    !error?.isSessionError &&
    count < 1;

function CustomQueryClientProvider({children}) {
    const {showError} = useFeedback();

    function onError(error) {
        error.isRequestError &&
            showError(error, {persist: false, preventDuplicate: true});
    }

    const [queryClient] = useState(
        () =>
            new QueryClient({
                queryCache: new QueryCache({onError}),
                defaultOptions: {
                    queries: {retry: retryQuery},
                    mutations: {retry: false}
                }
            })
    );
    useEffect(() => {
        let revision = getSessionStatus().revision;
        return subscribeSession(
            () => {
                const session = getSessionStatus();
                if (!session.hasAccess || session.revision !== revision) {
                    queryClient.cancelQueries();
                    queryClient.clear();
                }
                revision = session.revision;
            },
            {priority: true}
        );
    }, [queryClient]);

    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}

export default CustomQueryClientProvider;
